import AndrewJoseph from "../../assets/andrew-joseph.png";
import GeorgeAlan from  "../../assets/george-alan.png";
import NancyGrace from  "../../assets/nancy-grace.png";
import SusanMarie from  "../../assets/susan-marie.png";
import JohnPaul from  "../../assets/john-paul.png";

export const sampleUsers = {
    "users":[
        {
            "uid": "support_agent_1",
            "name": "Tallam Kemboi",
            "avatar": AndrewJoseph
        }
    ]
}